<div class="nav">
    <button (click)="show_help='dna_prote_conv'; scrollTo()" style="background-color: darkcyan;">DNA to Protein
        Conversion</button>
    <button (click)="show_help='liftover'; scrollTo()" style="background-color: goldenrod;">Genomic Liftover</button>
    <button (click)="show_help='prote_dna_conv'; scrollTo()" style="background-color: darkmagenta;">Protein to DNA
        Conversion</button>
    <button (click)="show_help='dna_prote_seq_conv'; scrollTo()" style="background-color: lightseagreen;">Convert DNA to
        Protein Sequence</button>
    <button (click)="show_help='gene_normalizer'; scrollTo()" style="background-color: darkolivegreen;">Gene Name
        Normalizer</button>
    <button (click)="show_help='reverse_comp'; scrollTo()" style="background-color: indianred;">Reverse
        Complement</button>
    <button (click)="show_help='get_transcr'; scrollTo()" style='background-color: darksalmon;'>Get Transcripts</button>
    <button (click)="show_help='exon_info'" style="background-color: rgb(71, 165, 42);">Exon Info</button>
    <button (click)="show_help='prot_seq'" style="background-color: darkslateblue;">Get Protein Sequence</button>
    <button (click)="show_help='fusion_check'" style="background-color: chocolate;">Fusion Check</button>
    <button (click)="show_help='pathway'" style="background-color: darkslategrey;">Visualize
        Pathway</button>
    <button (click)="show_help='dna_seq'" style="background-color: rgb(172, 5, 5);">DNA Sequence</button>
    <button (click)="show_help='aa_info'" style="background-color: #3E608C;">Amino Acid Info</button>
    <!-- <button (click)="show_help='InWork'">Amino Acid Table</button>
    <button (click)="show_help='InWork'">BLOSSUM Matrix</button> -->
</div>

<div class="main" id="helpsection">
    <div *ngIf="show_help=='dna_prote_conv'" class="fun">
        <h2>DNA to Protein Conversion</h2>
        <p>SeqCAT can convert DNA single nucleotide polymorphism into their corresponding protein exchanges.</p>

        <img class='small' src="./assets/images/help_images/reference_genome.png" alt="Reference Genome Selection" />
        <p><span>Reference Genome:</span> Select the reference genome your input data is based on. Can be either HG19
            (GRCh37) or hg38 (GRCh38).</p>

        <img src="./assets/images/help_images/dna_protein_conversion_input.png" alt="DNA_Protein_Conversion_Input" />
        <p><span>Input data:</span> The input data have to be single nucleotide polymorphism in the format
            'chr[N]:g.[Pos][Ref]>[Alt].
            With <span>N</span> the number of the chromosome, <span>Pos</span> the position on the chromosome based on
            your selected reference genome;
            <span>Ref</span> the reference nucleotide at the given position and <span>Alt</span> for the replaced
            nucleotide.
        </p>

        <img src="./assets/images/help_images/vcf_example.png" alt="VCF-File Example">
        <p><span>VCF-File:</span> The VCF-File allows you to get the most important information in one field. The
            results can be selected and copied.</p>

        <img src="./assets/images/help_images/dna_protein_conversion_output.png" alt="DNA_Protein_Conversion_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>Hugo Gene Name:</span> The <a href="https://www.genenames.org/">Hugo Gene Name</a> that is
                    located at input position.</li>
                <li><span>Used Transcript:</span> The used transcript (in general the found <a
                        href="https://www.ncbi.nlm.nih.gov/refseq/MANE/">MANE Select</a> transcript) for
                    mapping the nucleotide exchange to the corresponding amino acid exchange.</li>
                <li><span>Full Variant:</span> The full output with protein identifier, the reference and exchanged
                    amino acid in three-letter representation and the position of amino acid exchange.</li>
                <li><span>Variant Exchange:</span> Short version of the full variant. With reference and exchanged amino
                    acid in one-letter representation and the position of the amino acid exchange.</li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='liftover'" class="fun">
        <h2>Liftover</h2>
        <p>SeqCAT can convert genomic positions from one reference genome to another. Currently, only the conversion
            between hg19 (GRCh37) or hg38 (GRCh38) is possible, further conversions are in progress. The Conversion is
            based on the <a href="https://pypi.org/project/pyliftover/">pyliftover</a> python package.</p>

        <img class='small' src="./assets/images/help_images/reference_genome.png" alt="Reference Genome Selection" />
        <p><span>Reference Genome:</span> Select the reference genome your input data is based on. Can be either hg19
            (GRCh37) or hg38 (GRCh38).</p>

        <img src="./assets/images/help_images/liftover_input.png" alt="Liftover_Input" />
        <p><span>Input data:</span> The input data have to be position on the genome in the format
            'chr[N]:[Pos].
            With <span>N</span> the number of the chromosome, <span>Pos</span> the position on the chromosome based on
            your selected reference genome;
        </p>

        <img src="./assets/images/help_images/liftover_output.png" alt="Liftover_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>New Position:</span> The mapped new position to the other reference genome.</li>
                <li><span>Chromosome:</span> The chromosome based of the new position</li>
                <li><span>Strand:</span> The strand where the new position is located. Can be '+' for forward and '-'
                    for reverse strand.</li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='prote_dna_conv'" class="fun">
        <h2>Protein to DNA Conversion</h2>
        <p>SeqCAT can convert protein position mutation to their corresponding genomic positions. The conversion to the
            genomic position is ambiguous, SeqCAT only shows one possible result.</p>

        <img src="./assets/images/help_images/vcf_example.png" alt="VCF-File Example">
        <p><span>VCF-File:</span> The VCF-File allows you to get the most important information in one field. The
            results can be selected and copied.</p>

        <img class='small' src="./assets/images/help_images/reference_genome.png" alt="Reference Genome Selection" />
        <p><span>Reference Genome:</span> Select the reference genome your output data will be mapped to. Can be either
            hg19 (GRCh37) or hg38 (GRCh38).</p>

        <img src="./assets/images/help_images/protein_dna_conversion_input.png" alt="Protein_DNA_Input" />
        <p><span>Input data:</span> The input data have to be position on the genome in the format
            [Gene]:[Ref][Pos][Alt].<br>
            With <span>Gene</span> the HUGO gene name, <span>Ref</span> the reference aminoacid at the given position,
            <span>Pos</span> the position at the protein where the amino acid exchange is located and
            <span>Alt</span> with the exchanged amino acid.;
        </p>

        <img src="./assets/images/help_images/protein_dna_conversion_output.png" alt="Protein_DNA_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>New Position:</span> The mapped new position to the other reference genome with one possible
                    nucleotide exchange resulting into the protein mutation.</li>
                <li><span>Chromosome:</span> The chromosome based of the new position</li>
                <li><span>Nucleotide Exchange:</span> Shows the reference triplett of the mutation including all
                    possible exchanges that will results into the given amino acid exchange.</li>
                <li><span>Used Transcript:</span> The used transcript for mapping the protein position into genomic
                    position. </li>
                <li><span>cDNA Position:</span> The cDNA position and nucleotide exchange of the used transcript. </li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='dna_prote_seq_conv'" class="fun">
        <h2>Protein to DNA Conversion</h2>
        <p>SeqCAT can convert genomic sequences into their corresponding protein sequence. Amino acids are converted
            with the <a href="/SeqCAT/converter/converter-aa-table">Amino Acid Table</a>.</p>

        <img src="./assets/images/help_images/dna_protein_sequence_conversion_input.png" alt="DNA_Protein_Seq_Input" />
        <p><span>Input data:</span> A genomic sequence containing only the characters [A|T|C|G|a|t|c|g]<br>
        </p>

        <img src="./assets/images/help_images/dna_protein_sequence_conversion_output.png"
            alt="DNA_Protein_Seq_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>Warning:</span> Tells you whether something may be wrong in your input data. Possible warnings
                    are: Unsupported characters used or length of input sequence is not divisible by three.</li>
                <li><span>One-Letter Sequence:</span> The result sequence in one-letter representation. Tripletts that
                    could not converted correctly are replaced by a single '?'.</li>
                <li><span>Three-Letter Sequence:</span> The result sequence in three-letter representation. Tripletts
                    that could not converted correctly are replaced by a single '?'.</li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='gene_normalizer'" class="fun">
        <h2>Gene Normalizer</h2>
        <p>SeqCAT can normalize gene names to their approved HUGO symbols and gives you additional information about the
            input symbol.</p>

        <img src="./assets/images/help_images/gene_normalizer_input.png" alt="gene_normalizer_Input" />
        <p><span>Input data:</span> A HUGO gene name.<br>
        </p>

        <img src="./assets/images/help_images/gene_normalizer_output.png" alt="gene_normalizer_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>Is Approved:</span> Tells you whether you input symbol is already the approved symbol or not.
                </li>
                <li><span>Approved Symbol:</span> The approved symbol to use based on HUGO.</li>
                <li><span>Approved Name:</span> The full name of the gene.</li>
                <li><span>HGNC ID:</span> The HGNC identifier with hyperlink to HUGO.</li>
                <li><span>Previous Symbols:</span> The previous symbols based on HUGO.</li>
                <li><span>Alias Symbols:</span> The previous alias' based on HUGO.</li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='reverse_comp'" class="fun">
        <h2>Reverse Complement</h2>
        <p>SeqCAT can convert genomic sequences into their reverse, complement or reverse complemet sequence.</p>

        <img src="./assets/images/help_images/reverse_complment_type.png" alt="reverse_complement_Type" />
        <div>
            <p><span>Conversion Type:</span> A HUGO gene name.<br></p>
            <ul>
                <li><span>Reverse Complement:</span> Returns the reverted complement of the input sequence.</li>
                <li><span>Complement:</span> Returns the complement of the input sequence.</li>
                <li><span>Reverse:</span> Returns the input sequence reverted.</li>
            </ul>
        </div>

        <img src="./assets/images/help_images/reverse_complment_input.png" alt="reverse_complement_Input" />
        <p><span>Input data:</span> A genomic sequence containing only the characters [A|T|C|G|N|a|t|c|g|n]<br>
        </p>

        <img src="./assets/images/help_images/reverse_complment_output.png" alt="reverse_complement_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>Response Sequence:</span> The result genomic sequence manipulated by used conversion type. Not
                    supported nucelotides are replaces with a '?'.</li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='get_transcr'" class="fun">
        <h2>Get Transcripts</h2>
        <p>SeqCAT can return information about transcripts based on gene names or NCBI-transcripts.</p>

        <img class='small' src="./assets/images/help_images/reference_genome.png" alt="Reference Genome Selection" />
        <p><span>Reference Genome:</span> Select the reference genome your input data is based on. Can be either hg19
            (GRCh37) or hg38 (GRCh38).</p>

        <img src="./assets/images/help_images/get_transcripts_input.png" alt="get_transcript_Input" />
        <p><span>Input data:</span> A HUGO gene name.<br>
        </p>

        <img src="./assets/images/help_images/get_transcripts_output.png" alt="get_transcript_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>MANE Transcripts:</span> The MANE Select Transcript for Ensembl and Ensembl.</li>
                <li><span>NCBI Transcripts:</span> A list of other available NCBI transcripts in the database.</li>
                <li><span>Ensembl Transcripts:</span> A list of other available Ensembl transcripts in the database.
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='exon_info'" class="fun">
        <h2>Exon Info</h2>
        <p>SeqCAT can show informatio of exons based on an input gene name.</p>

        <img class='small' src="./assets/images/help_images/reference_genome.png" alt="Reference Genome Selection" />
        <p><span>Reference Genome:</span> Select the reference genome your input data is based on. Can be either hg19
            (GRCh37) or hg38 (GRCh38).</p>

        <img src="./assets/images/help_images/exon_info_input.png" alt="exon_info_Input" />
        <p><span>Input data:</span> A HUGO gene name.<br>
        </p>

        <img src="./assets/images/help_images/exon_info_output.png" alt="exon_info_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                boxes with information for each exon.</p>
            <ul>
                <li><span>Exon #:</span> The number of the exon.</li>
                <li><span>Chromosome:</span> The chromosome the exon is located.</li>
                <li><span>Strand:</span> The strand the exon is located.</li>
                <li><span>Transcript:</span> The MANE-Select transcript used for the input gene. </li>
                <li><span>Chromosom Start Position:</span> The start posisiton of the exon on the chromosome.</li>
                <li><span>Chromosom End Position:</span> The end posisiton of the exon on the chromosome.</li>
                <li><span>CDS Start Position:</span> The CDS start for this transcript.</li>
                <li><span>CDS End Position:</span> The CDS end for this transcript.</li>
                <li><span>Exon Start Position:</span> The start position of the exon on the transcript. </li>
                <li><span>Exon End Position:</span> The end position of the exon on the transcript.</li>
                <li><span>Exon Length:</span> The length of the exon. From CDS start to CDS end.</li>
            </ul>
        </div>
    </div>


    <!-- ADD Descriptions HERE -->

    <div *ngIf="show_help=='fusion_check'" class="fun">
        <h2>Fusion Check</h2>
        <p>SeqCAT can interpret fusions and returns information whether the involved proteins underlie frameshifts.
            (Currently only supported for hg38(GRCh38))</p>

        <img src="./assets/images/help_images/fusion_check_input.png" alt="exon_info_Input" />
        <p><span>Input data:</span> A gene fusion with its chomosomal breakpoints.<br>
        </p>

        <img src="./assets/images/help_images/fusion_check_output.png" alt="fusion_check_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                boxes with information for each exon.</p>
            <ul>
                <li><span>Fusion In-Frame:</span> Shows the status of the proteins within the fusion. Out-of-Frame: Both
                    proteins have a frameshift. In-Frame: Proteins are merged in in-frame.</li>
                <li><span>Breakpoint 1 & 2 - Info: </span> The breakpoint position from the input.</li>
                <ul>
                    <li><span>Gene Name:</span> The gene name found at the input position.</li>
                    <li><span>Position In-Frame:</span> The breakpoint position of the protein is in frame or not. </li>
                    <li><span>Position in triplett:</span> The position of the breakpoint based on the triplett. 0 means
                        directly at the start of the triplett. </li>
                    <li><span>Strand:</span> The strand, the protein is located</li>
                    <li><span>Target Exon:</span> The exon of the protein where the breakpoint is located. </li>
                    <li><span>Used Transcript:</span> The MANE-Select transcript used to get information about the
                        protein. </li>
                </ul>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='prot_seq'" class="fun">
        <h2>Protein Sequence</h2>
        <p>SeqCAT can return a protein sequence or maniplulate protein sequences based on a given gene name and variant
            annotations.</p>

        <img src="./assets/images/help_images/prot_seq_input.png" alt="prot_seq_Input" />
        <p><span>Input data:</span> A HUGO gene name and optional the aminoacid exchange you want to include in your sequence. <br>
        </p>

        <img src="./assets/images/help_images/prot_seq_output.png" alt="prot_seq_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>Protein ID:</span> The Protein ID used to get the sequence.</li>
                <li><span>Protein Sequence:</span> The protein sequence with built in exchanges.</li>
            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='dna_seq'" class="fun">
        <h2>'DNA Sequence</h2>
        <p>SeqCAT can return a dna-sequence based on start and stop position of a chromosome.</p>

        <img class='small' src="./assets/images/help_images/reference_genome.png" alt="Reference Genome Selection" />
        <p><span>Reference Genome:</span> Select the reference genome your input data is based on. Can be either hg19
            (GRCh37) or hg38 (GRCh38).</p>

        <img src="./assets/images/help_images/dna_seq_input.png" alt="dna_seq_Input" />
        <p><span>Input data:</span> The chromosome with start and stop position.<br>
        </p>

        <img src="./assets/images/help_images/dna_seq_output.png" alt="dna_seq_Output" />
        <div>
            <p><span>Output data:</span> The output card shows in the header the given input and as content different
                types of information.</p>
            <ul>
                <li><span>DNA Sequence:</span> The DNA sequence based on the chromosome, start and stop posisiton.</li>

            </ul>
        </div>
    </div>

    <div *ngIf="show_help=='aa_info'" class="fun">
        <h2>Amino Acid Info</h2>
        <p>SeqCAT gives detailed information about each aminoacid.</p>

        <img src="./assets/images/help_images/amino_acid_info_front.png" alt="amino_acid_info_front" />
        <p><span>Front Card:</span> Shows aminoacids and their structure. Hovering over the card flips it to its back
            side for detailed information. Clicking on the card redirects to the Wikipedia page.<br>
        </p>

        <img src="./assets/images/help_images/amino_acid_info_back.png" alt="amino_acid_info_back" />
        <div>
            <p><span>Back Card:</span> The back site shows detailed information to each aminoacid, like mass, charge,
                polarity, volume and more.</p>
        </div>
    </div>


    <div *ngIf="show_help=='pathway'" class="fun">
        <h2>Visualize Pathway</h2>
        <p>SeqCAT can visualize KEGG Pathways and show them in an interactive visual viewer.</p>

        <img src="./assets/images/help_images/visualize_pathway_input.png" alt="visualize_pathway_Input" />
        <p><span>Input data:</span> Select a pathway you are interested in visualizing.<br>
        </p>

        <img src="./assets/images/help_images/visualize_pathway_output.png" alt="visualize_pathway_Output" />
        <div>
            <p><span>Output data:</span> The interactive graph shows genes and how they interact with each other. The colored edges highlight different interactions:</p>
            <ul>
                <li><span style="color:red">Red:</span> Activation</li>
                <li><span style="color:blue">Blue:</span> Inhibition</li>
                <li><span style="color:green">Green:</span> Expression</li>
                <li><span style="color:yellow">Yellow:</span> Repression</li>
                <li><span style="color:orange">Orange:</span> Indirect Effect</li>
                <li><span style="color:purple">Purple:</span> State Change</li>
                <li><span style="color:hotpink">Pink:</span> Binding/Association</li>
                <li><span style="color:brown">Brown:</span> Dissociation</li>
                <li><span style="color:black">Black:</span> Missing Interaction</li>
                <li><span style="color:gray">Gray:</span> Phosphorylation</li>
                <li><span style="color:cyan">Cyan:</span> Dephosphorylation</li>
                <li><span style="color:magenta">Magenta:</span> Glycosylation</li>
                <li><span style="color:lime">Lime:</span> Ubiquitination</li>
                <li><span style="color:olive">Olive:</span> Methylation</li>
            </ul>
            <p><span>Output data:</span> The right field allows you to manipulate the simulation of nodes or export the graph as image file.</p>
        </div>
    </div>


    <div *ngIf="show_help=='InWork'">
        <div style="display:grid; justify-content: center; justify-items: center; margin-top: 50px;">
            <img src="assets/images/construction-rounded.svg" style="height:300px;width:300px">
            <div style="font-size: xx-large;">PAGE UNDER CONSTRUCTION</div>
        </div>
    </div>
</div>